export const EDIT_FIELDS = ['capabilities_edit', 'services_edit'];
